import React from 'react'
import PropTypes from 'prop-types'

const TitleSection = ({
  isOpen,
  toggleSection,
  isDifferent,
  isNew,
  selected,
  formData,
  handleSelectionChange,
  handleInputChange,
  isRegistrationFlow,
}) => {
  const maxLength = 128
  const remaining = Math.max(maxLength - formData.analyseData.title.length, 0)

  return (
    <div className="mb-5">
      <div className="mb-3 d-flex align-items-center" onClick={() => toggleSection('title')} style={{ cursor: 'pointer' }}>
        <span className="form-title-chip rounded-circle mr-2">1</span>

        <h4 className="mb-0">Titre de votre fiche</h4>

        <span className={`badge badge-${isNew ? 'primary text-white' : (isDifferent ? 'info' : 'success')} ml-2`}>
          { isNew ? 'Nouveau' : (isDifferent ? 'Différent' : 'Identique') }
        </span>

        <small className="helper ml-3">
          {remaining} caractère{remaining > 1 ? 's' : ''} restant{remaining > 1 ? 's' : ''}
        </small>

        <span className="ml-auto h3 text-secondary mb-0">{isOpen ? '-' : '+'}</span>
      </div>

      { isOpen && (
        <div className="row">
          <div className={`col-md-${isDifferent ? '6' : '12'}`}>
            <div className={`mb-3 ${isDifferent ? 'p-3 border rounded' : ''} ${selected === 'analyseData' ? '' : 'border-light'}`}>
              { isDifferent ? (
                <div className="custom-control custom-switch mb-2">
                  <input
                    className="custom-control-input"
                    type="checkbox"
                    id="title-analyse"
                    checked={selected === 'analyseData'}
                    onChange={() => handleSelectionChange('general', 'title', 'analyseData')}
                  />

                  <label className="custom-control-label" htmlFor="title-analyse">
                    Nouvelle donnée du CV
                  </label>
                </div>
              ) : null }

              <div style={{ opacity: isDifferent && selected !== 'analyseData' ? 0.5 : 1 }}>
                <textarea
                  className="form-control"
                  name="title"
                  rows="2"
                  maxLength={maxLength}
                  value={formData.analyseData.title}
                  disabled={selected !== 'analyseData'}
                  onChange={(e) => handleInputChange('analyseData', 'title', e.target.value)}
                />
              </div>
            </div>
          </div>

          { isDifferent ? (
            <div className="col-md-6">
              <div className={`p-3 mb-3 border rounded ${selected === 'freelanceData' ? '' : 'border-light'}`}>
                <div className="custom-control custom-switch mb-2">
                  <input
                    className="custom-control-input"
                    type="checkbox"
                    id="title-freelance"
                    checked={selected === 'freelanceData'}
                    onChange={() => handleSelectionChange('general', 'title', 'freelanceData')}
                  />

                  <label className="custom-control-label" htmlFor="title-freelance">
                    Donnée actuelle
                  </label>
                </div>

                <div style={{ opacity: isDifferent && selected !== 'freelanceData' ? 0.5 : 1 }}>
                  <textarea
                    className="form-control"
                    name="title"
                    rows="2"
                    maxLength={maxLength}
                    value={formData.freelanceData.title}
                    disabled={selected !== 'freelanceData'}
                    onChange={(e) => handleInputChange('freelanceData', 'title', e.target.value)}
                  />
                </div>
              </div>
            </div>
          ) : null }
        </div>
      )}
    </div>
  )
}

TitleSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleSection: PropTypes.func.isRequired,
  isDifferent: PropTypes.bool.isRequired,
  isNew: PropTypes.bool.isRequired,
  selected: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  handleSelectionChange: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  isRegistrationFlow: PropTypes.bool.isRequired,
}

TitleSection.defaultProps = {
  isRegistrationFlow: false,
}

export default TitleSection
